// extracted by mini-css-extract-plugin
export default {"themeToggleButton":"AnimatedThemeToggler_themeToggleButton__iXmeK","boxDemo":"AnimatedThemeToggler_boxDemo__nPHQe"};